import TriggerMobileMenu from './TriggerMobileMenu'

export default TriggerMobileMenu
